export default [
	{ label: 'Event', key: 'name' },
	{ label: 'StartDate', key: 'startDate' },
	{ label: 'Day', key: 'day' },
	{ label: 'Men', key: 'men' },
	{ label: 'Women', key: 'women' }
 ]


// WEBPACK FOOTER //
// ./src/components/pages/Report/constants/oilratioHeaders.js